import React, { Component } from 'react';
import { observer } from 'mobx-react';
import envStore from '../request/model';
import styleJson from 'common/config/map/bmap_config.json';
import './index.styl';

const BMap = window.BMap;
const clzpre = 'dsh-map';
const center = [116.13657757000628, 39.03500143875472]; // 梁场环参设备 作为地图中心

const deviceList = [
    { location: [116.13657757000628, 39.03500143875472], name: '梁场[ID:40054502]' },
    { location: [116.13857757000628, 39.03900143875472], name: '保静路口[ID:40053908]' },
    { location: [116.13357757000628, 39.03100143875472], name: '备用设备[ID:40051075]' }
];

const locationIcon = require('common/images/map-location.svg');
const locationActive = require('common/images/map-location-active.svg');

const labelStyle = {
    color: '#EAA80D',
    fontSize: '16px',
    height: '20px',
    lineHeight: '20px',
    fontFamily: '微软雅黑',
    border: 'none',
    backgroundColor: 'transparent'
};

@observer
class Map extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.initMap();
    }

    componentDidUpdate() {
        this.setDeivces();
    }

    initMap = () => {
        const map = new BMap.Map('map');
        map.centerAndZoom(new BMap.Point(...center), 15);
        map.setMapStyleV2({ styleJson });
        map.enableScrollWheelZoom();
        this.map = map;

        this.setDeivces();
    };

    setDeivces = () => {
        this.map.clearOverlays(); 
        const {devices} = this.props.envStore || {};
        devices.map(device => {
            this.setDevice([device.jingdu, device.weidu], device);
        });
    }

    setDevice = (location, device) => {
        const name = device.name;
        const isCurrent = this.props.current === device.id;

        const point = new BMap.Point(...location);
        const opts = { position: point, offset: new BMap.Size(15, -20) };
        let label = new BMap.Label(name, opts);
        label.setStyle({...labelStyle, color: isCurrent ? '#02eeff' : labelStyle.color});
        this.map.addOverlay(label);

        const icon = isCurrent ? locationActive : locationIcon;
        const myIcon = new BMap.Icon(icon, new BMap.Size(18, 36), {
            imageSize: new BMap.Size(18, 18),
            imageOffset: new BMap.Size(0, 0)
        });
        this.map.addOverlay(new BMap.Marker(point, { icon: myIcon }));
    };

    render() {
        return (
            <div className={clzpre}>
                <div className={`${clzpre}-dom`} id="map"></div>
            </div>
        );
    }
}

export default props => <Map {...props} envStore={envStore} />;
